import { render, staticRenderFns } from "./TipoLicenciaModalNuevo.vue?vue&type=template&id=4dc38bae&scoped=true&"
import script from "./TipoLicenciaModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoLicenciaModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLicenciaModalNuevo.vue?vue&type=style&index=0&id=4dc38bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc38bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4dc38bae', component.options)
    } else {
      api.reload('4dc38bae', component.options)
    }
    module.hot.accept("./TipoLicenciaModalNuevo.vue?vue&type=template&id=4dc38bae&scoped=true&", function () {
      api.rerender('4dc38bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipoLicenciaModalNuevo.vue"
export default component.exports